import React, { useState, useEffect, useRef } from 'react';
import { useStore } from 'store';
import { Button } from 'react-bootstrap';
import { ErrorModal } from 'components';
import { hideLoader, showLoader } from 'store/actions/commons';
import { postValidateExcel } from 'services/rsvp/getRSVP';
import verifica from 'assets/img/verifica.png';
import cirulo_error from 'assets/img/cirulo_error.png';

const TemplateUpload = ({ typeId, handleNextStepsFather, handleUrlFather, handleTimeSleepFather }) => {
    const [, dispatch] = useStore((state) => state.giftTable.giftTable);
    const [jsonResultado, setJsonResultado] = useState(null);
    const [showTrueModal, setShowTrueModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);

    const handleClickConfirm = () => {
        handleNextStepsFather();
        setShowTrueModal(false);
    };

    const handleClose = () => {
        setShowErrorModal(false);
        setShowTrueModal(false);
    };

    const handleClickError = () => {
        setShowErrorModal(false);;
    };

    const handleFileChange = (e) => {
        console.log('Convirtiendo archivo a base 64 ');
        const file = e.target.files[0];
        if (file) {
            // Crear un objeto FileReader
            const reader = new FileReader();
            const nombreArchivo = file.name;
            // setTypeId(tableInfo?.evento);
            // Configurar el evento onload del lector de archivos
            reader.onload = (event) => {
                // El resultado del lector de archivos es el contenido en base64
                const base64Data = event.target.result;
                dispatch(showLoader());
                if (base64Data) {
                    console.log('Nombre archivo: ', nombreArchivo);
                    console.log('archivo: ', base64Data)
                    const nuevoRegistro = {
                        typeId,
                        nombreArchivo,
                        base64Data
                    };
                    setJsonResultado(nuevoRegistro);
                } else {
                    dispatch(hideLoader());
                    setShowErrorModal(true);
                }
            };
            // Leer el archivo como base64
            reader.readAsDataURL(file);
        }
    };

    useEffect(() => {
        //    ENVIAR DATA A SERVICIO CARGA EXCEL
        if (jsonResultado) {
            console.log('jsonResultado en hijo ', jsonResultado);
            // Valida la respuesta del backend    -----------------------------------------------------
            postValidateExcel(typeId, jsonResultado).then((valorDeServicio) => {
                console.log('postValidateExcel ', valorDeServicio);
                if (valorDeServicio?.data?.status === 'success') {
                    setShowTrueModal(true);
                    handleUrlFather(valorDeServicio?.data);
                    handleTimeSleepFather(valorDeServicio?.data?.seg)
                } else {
                    console.log('Archivo sube mal ');
                    setShowErrorModal(true);
                    console.log('Errores al subir el acrhivo: ', valorDeServicio?.data?.detalle_errors)
                }

                // Valida la respuesta del backend
                dispatch(hideLoader());
            });

        }
    }, [jsonResultado]);

    const inputRef = useRef(null);

    const handleButtonClick = () => {
        inputRef.current.click();
    };

    return (
        <>
            <input
                ref={inputRef}
                type="file"
                accept=".xlsx"
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />
            <Button
                id={22}
                block
                variant="primary"
                onClick={handleButtonClick}
                type="button">
                Subir plantilla
            </Button>
            <ErrorModal
                show={showTrueModal}
                title=""
                titleHeader=""
                icon={verifica}
                titleHeaderClassName="col-md-12 offset-md-3"
                actionLabel="Entendido"
                onAction={handleClickConfirm}
                onClose={handleClose}
                showCancel={false}
                closeLabel=''
                subtitle={
                    <p className="text-center">
                        <b>¡Tu archivo se subió<br />con exito!<br /></b>
                    </p>
                }
            />

            <ErrorModal
                show={showErrorModal}
                title=""
                titleHeader=""
                icon={cirulo_error}
                titleHeaderClassName="col-md-12 offset-md-3"
                actionLabel="Entendido"
                onAction={handleClickError}
                onClose={handleClose}
                showCancel={false}
                closeLabel=''
                subtitle={
                    <p className="text-center">
                        <h2><b>¡Hubo un error al<br />cargar tu archivo!</b></h2><br />Formato erróneo<br />
                    </p>
                }
            />
        </>
    );
};

export default TemplateUpload;